export default __webpack_public_path__ + "static/media/analytics.36c71d45.svg";